import math from "@libs/js/mathjs";

// 数值(用作有效判定)
// 用法：regExpTestNumber.test(value)
export const regExpTestNumber = /^([+-])?(\d)*(\.)?(\d)*$/;

// 数值(可输入)
// 用法：value.replace(regExpInputNumber, "")
export const regExpInputNumber = /[^\-?\d.]/g;

// 添加金额分隔符(,)
// 用法：value.replace(regExpAmountSplit, ",")
export const regExpAmountSplit = /\B(?=(\d{3})+(?!\d))/g;

export function useFormatAmount() {
  // 验证金额数值的有效性
  function validAmount(val) {
    if (
      (val || val === 0) &&
      regExpTestNumber.test(val.toString()) &&
      !_.isNaN(Number(val))
    ) {
      return true;
    } else {
      return false;
    }
  }

  // 保留符号（输入操作中间状态）
  function isReservedSymbol(val) {
    return val === "-" || val === "." || val === "";
  }

  // 输入有效数值的过滤器
  function inputNumberFilter(value, format) {
    if (value) {
      value = value.toString();

      if (format === "int") {
        // 仅整数
        value = value.replace(/[^0-9\-]/, "");
      } else if (format === "+int") {
        // 仅正整数
        value = value.replace(/[^0-9]/, "");
      } else if (format === "-int") {
        // 仅负整数
        value = value.replace(/[^0-9]/, "");
        value = "-" + value;
      } else {
        value = value.toString().replace(/。/, ".").replace(/=/, "-");
        // console.log(value)
        value = value.replace(regExpInputNumber, "");
        // console.log(value)
        // 去除负号前的内容
        value = value.replace(/.*(\-.*)/, "$1");
        // 矫正负号和小数的点位置
        value = value.replace(/.*\-\.(.*)/, "-0.$1");
        // console.log(value)
        // 去除多余小数点
        value = value.replace(/(.*\..*)\./, "$1");
        // console.log(value)
        // 去除整数0开头的多余的0
        value = value.replace(/^[0]+([1-9])/, "$1");
        // console.log(value)
        // 去除浮点数多余的0 如: 011.020300 =》 11.0203
        // value = value.replace(/0*([1-9]\d*|0\.\d+)/, "$1")
        value = value.replace(/^0+\.(.*)/g, "0.$1");
        // console.log(value)
        // value = value.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
        // value = value.replace(/(.*\.[^0])0+$/g, "$1")
        // value = value.replace(/(\.0{0,2}[^0]*)0+?$/, "$1")

        // console.log(value)
        if (format === "+number") {
          // 仅正数
          value = value.replace(/^\-/, "");
        } else if (format === "-number") {
          // 仅负数
          if (!/^\-/.test(value)) {
            value = "-" + value;
          }
        }
      }
    }
    return value;
  }
  // 格式为金额字符串
  function formatAmount(value, format, fractionLength = 2) {
    let val = inputNumberFilter(value, format);
    // console.log(val)
    if (isReservedSymbol(val)) {
      return "";
    }
    if (validAmount(val)) {
      const arr = math
        .format(math.bignumber(val), {
          notation: "fixed",
          precision: fractionLength,
          isBankToFixed: true,
        })
        .split(".");

      arr[0] = arr[0].replace(regExpAmountSplit, ",");
      // return "¥" + strVal
      return arr.join(".");
    }
    return "";
  }

  return {
    validAmount,
    isReservedSymbol,
    inputNumberFilter,
    formatAmount,
  };
}
